import { render, staticRenderFns } from "./SchoolListPopover.vue?vue&type=template&id=201cb6f2&"
import script from "./SchoolListPopover.vue?vue&type=script&lang=js&"
export * from "./SchoolListPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports